import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";

import { testQuestionSingleResourceType } from "../resources/testQuestionSingle/testQuestionSingleResourceConsts";
import {
  completeTutorialTestPath,
  testAnswerSingleResourceType,
} from "../resources/tutorialTest/tutorialTestResourceConsts";

type AnswersPayload = {
  answerIndex: string;
  questionId: string;
};

type CompleteTutorialMutationPayload = {
  companyId: string;
  tutorialId: string;
  tutorialVersion: string;
  answers: AnswersPayload[];
};

export function completeTutorialTestMutation(jsonApi: JsonApiClient) {
  return ({
    companyId,
    tutorialId,
    tutorialVersion,
    answers,
  }: CompleteTutorialMutationPayload) => {
    return jsonApi.createMany({
      path: completeTutorialTestPath(companyId, tutorialId),
      requestData: {
        data: answers.map((answer) => ({
          type: testAnswerSingleResourceType,
          attributes: {
            answers: [Number(answer.answerIndex)],
          },
          relationships: {
            question: {
              data: {
                type: testQuestionSingleResourceType,
                id: answer.questionId,
              },
            },
          },
        })),
        meta: {
          tutorialVersion,
        },
      },
    });
  };
}
